import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { Button, IconName, TableHeader } from '@optimus-web/core';
import { usePrivilege } from '@mews-commander/core';
import { useRateGroupDialogForm } from '../forms';

interface RateGroupTableHeaderProps {
    subTitle: ReactNode;
}

export const RateGroupTableHeader = ({ subTitle }: RateGroupTableHeaderProps) => {
    const [renderDialog, toggleDialog] = useRateGroupDialogForm();
    const canManageRateGroups = usePrivilege('manageRateGroups');
    return (
        <>
            <TableHeader
                title={lt('RateGroupPlural')}
                subTitle={subTitle}
                rightSide={
                    canManageRateGroups ? (
                        <Button icon={IconName.Add} onClick={toggleDialog} size="small" type="submit">
                            {lt('RateGroupCreate')}
                        </Button>
                    ) : null
                }
            />
            {renderDialog()}
        </>
    );
};
